import { Customer } from "../Interface/Login.interface";

export const getStoredAuth = (): string => {
  return localStorage.getItem('auth') ?? '';
};



 export const getStoredAuthCus = (): Customer[] => {
  const stored = localStorage.getItem('auth');
  if (!stored) return [];
  try {
    return JSON.parse(stored);
  } catch (err) {
    console.error("Invalid auth JSON", err);
    return [];
  }
};